import React from 'react';
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const RenderingUtils = require('../utils/rendering');
const createReactClass = require('create-react-class');

const CheckboxGroup = createReactClass({
  propTypes: {
    onChange: PropTypes.func.isRequired,
    valueEqualityCheck: PropTypes.func,
    name: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.any).isRequired,
    children: PropTypes.node,
  },

  childContextTypes: {
    checkboxGroup: PropTypes.shape({
      onChange: PropTypes.func,
      selectedValues: PropTypes.arrayOf(PropTypes.any).isRequired,
      name: PropTypes.string,
    }),
  },

  mixins: [PureRenderMixin],

  getDefaultProps() {
    return {
      valueEqualityCheck(valueA, valueB) {
        return valueA === valueB;
      },
    };
  },

  getChildContext() {
    return {
      checkboxGroup: {
        onChange: this._onChange,
        valueEqualityCheck: this.props.valueEqualityCheck,
        selectedValues: this.props.values,
        name: this.props.name || this.backupName,
      },
    };
  },

  UNSAFE_componentWillMount() {
    this.backupName = RenderingUtils.uniqueId('vogue-checkbox-group');
  },

  _onChange(value, { target: { checked } }) {
    const { valueEqualityCheck, onChange, values: currentValues } = this.props;

    const newValues = checked ?
      [...currentValues, value] :
      currentValues.filter(v => !valueEqualityCheck(value, v));

    onChange(newValues);
  },

  render() {
    return <span>{ this.props.children }</span>;
  },
});

module.exports = CheckboxGroup;
